import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InvoicingState, Order, Sample } from 'models/order';
import { User } from 'models/user';
import { Box, Button } from '@mui/material';
import SampleContent from './sample-content.component';
import SampleMethodDialog from './sample-method-dialog.component';
import { permissions } from 'utils/permission';

type SamplePackageSectionProps = {
    order: Order;
    currentUser: User;
    versionCheck: boolean;
};
const SamplePackageSection: FC<SamplePackageSectionProps> = ({
    order,
    currentUser,
    versionCheck,
}: SamplePackageSectionProps) => {
    const { t: translate } = useTranslation(['common']);
    const [sampleMethodDialogOpen, setSampleMethodDialogOpen] = useState(false);

    const handleCloseDialog = () => {
        setSampleMethodDialogOpen(false);
    };

    const modifyLocked = () => {
        return order.isProductionFinished || order.invoicingState !== InvoicingState.NOT_READY;
    };

    return (
        <Fragment>
            <Box display="flex" alignItems="center">
                <Box flexGrow={1}>
                    <SampleContent
                        originalSample={order.originalOrder.deliveryDetails.sample as Sample}
                        sample={order.deliveryDetails.sample as Sample}
                    />
                </Box>
                {!permissions.isExternalTechnician(currentUser?.role) && versionCheck && !modifyLocked() ? (
                    <Button onClick={() => setSampleMethodDialogOpen(true)} data-test="sample-section.edit-btn">
                        {translate('common:EDIT')}
                    </Button>
                ) : undefined}
            </Box>
            <SampleMethodDialog open={sampleMethodDialogOpen} onClose={handleCloseDialog} order={order} />
        </Fragment>
    );
};

export default SamplePackageSection;
